import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Root from "./root";
import { BASE_SITE, CHECK_LOGIN_GET } from '../apis';
import { handleSetOpenCustomSnackbar } from '../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../redux/actions/loaders';
import { handleChangeProfileData, handleChangeToken, actionLogOutUser } from '../redux/actions/pages/user/login';


const App = () => {
	
	const dispatch = useDispatch();

	const { token } = useSelector((state: any) => state.login);

	useEffect(() => {
        handleCheckedLoginAndOtherData();
        // eslint-disable-next-line
    }, [App]);


    const handleCheckedLoginAndOtherData = () => {

    	if(token) {
    		dispatch(handleSetBackdropLoading(true));
    		
    		axios({
	            method: 'get',
	            url: BASE_SITE + CHECK_LOGIN_GET,
	            headers: {
	                'Accept': 'application/json',
	                'Content-Type': 'application/x-www-form-urlencoded',
	                'Authorization': token,
	            },
	        }).then((response) => {
	            switch (response.data.status) {
	                case 'error':
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
	                    break;
                    case 're_login':
	                	dispatch(actionLogOutUser());
	                    break;
	                case 'ok':
	                    dispatch(handleChangeProfileData(response.data.info));
	                    break;
	                default:
	                	dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
	            }
	            dispatch(handleSetBackdropLoading(false));
	        }, () => {
	            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
	            dispatch(handleSetBackdropLoading(false));
	        });   		
    	}
    };

	return (
        <div id={'app'} className={'rtl'}>
            <Root/>
        </div>
    )
}

export default memo(App);
